/**
 * A call row's direction, read the way the server reads it
 * (Xale-Server-API `call-outcome.where.ts`): both vocabularies — TeleCMI's
 * INBOUND / OUTBOUND and the native sync's INCOMING / OUTGOING — in any
 * casing, with the legacy `missed` direction counted as inbound. Anything
 * else (e.g. `unknown` device history) is unresolved → null.
 */
export type CallDirection = "in" | "out";

const IN = new Set(["inbound", "incoming", "in", "missed"]);
const OUT = new Set(["outbound", "outgoing", "out"]);

export function callDirectionOf(direction: unknown): CallDirection | null {
  const d = String(direction ?? "").trim().toLowerCase();
  if (IN.has(d)) return "in";
  if (OUT.has(d)) return "out";
  return null;
}
